import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useRef, useState } from 'react';
import { postAllData } from '../../service/ProductService';
import { SCRUTINY_HOLD } from '../../config/ApiConstant';
import { useNavigate } from 'react-router-dom';

const ScrutinyHoldModal = (props: any) => {
    const toast = useRef<any>(null);
    const navigate = useNavigate();
  

    const [holdBtnSpinner, setHoldBtnSpinner] = useState<boolean>(false);

    const holdScrutiny = async () => {
        try {
            setHoldBtnSpinner(true);

            // Request Data
            let requestData = {
                SrNo: props?.srNo,
                type: props?.status
            };

            // Api Call
            const response = await postAllData(SCRUTINY_HOLD, requestData);

            if (response) {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setHoldBtnSpinner(false);
                props.dismissClick();
                setTimeout(() => {
                    props.appName === 'Fresh Registration Other State' ? navigate(`/app/scrutiny/other-state-scrutiny/${props?.activeIndex}`) : props.appName === 'Transfer In' ? navigate(`/app/scrutiny/transfer-to-gujarat-scrutiny/${props?.activeIndex}`) : props.appName === 'Transfer DD/DNH' ? navigate(`/app/scrutiny/transfer-to-dd-dnh-scrutiny/${props?.activeIndex}`)  : navigate(`/app/scrutiny/fresh-registration-scrutiny/${props?.activeIndex}`);
                }, 1500);
            }
        } catch (error: any) {
            if (error.response) {
                setHoldBtnSpinner(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });

                props.dismissClick();
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.openmodel}
                className="p-fluid"
                style={{ width: '600px' }}
                header="Hold / Unhold  Scrutiny"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => props.dismissClick()} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => holdScrutiny()} loading={holdBtnSpinner} />
                    </>
                }
                onHide={() => props.dismissClick()}
            >
                <h5 className="bold">Are you sure you want to hold / unhold this scrutiny application ?</h5>
            </Dialog>
        </>
    );
};
export default ScrutinyHoldModal;
